export default __webpack_public_path__ + "static/media/lvbt.aad7aa30.png";